module.exports = "<template> <div class=tyl-skeleton part=root></div> </template>";